import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import DrawerComponent from "ProfileComponents/common/DrawerComponent";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import styles from "./styles.module.css";
function SupplementFacts(props) {
    const isMobile = useScreenWidth() < 999;
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const openDrawer = () => {
        setIsDrawerOpen(true);
    };
    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx("button", { className: styles.factsbtn, onClick: openDrawer, type: "button", children: "full supplement facts" }), _jsx(DrawerComponent, { open: isDrawerOpen, toggleDrawer: () => closeDrawer, anchor: isMobile ? "bottom" : "right", crossButton: true, children: _jsxs("div", { className: styles.modalwrapper, children: [_jsxs("div", { className: styles.modalheader, children: [props.title, " supplement facts"] }), _jsx("div", { className: styles.imagewrapper, children: props.image && _jsx("img", { src: props.image, alt: "additional info" }) })] }) })] }));
}
export default SupplementFacts;
